import { IOrderType } from '../../../interfaces/order';

export const requestTypeList: string[] = ['manual', 'sbp'];

export const getRequestTypeWithTranslates = (
  translates: {
    [type: string]: string;
  },
): IOrderType[] => {
  const requestTypes: IOrderType[] = requestTypeList.map(item => ({
    type: item,
    translate: translates[item],
  }));
  return requestTypes;
};
